export enum CustomInsightType {
    MENTION_INSIGHTS = 'MENTION_INSIGHTS',
    BRIEFING_ANALYSIS_BLOCK = 'BRIEFING_ANALYSIS_BLOCK',
    /** Curation criteria for a briefing's curator */
    BRIEFING_CURATOR = 'BRIEFING_CURATOR',
    /** Curation criteria for a curation agent. Saving one has agents-service generate the criteria */
    COVERAGE_CURATION = 'COVERAGE_CURATION'
}
